import { render, staticRenderFns } from "./autocomplete-program.vue?vue&type=template&id=51303d5f&"
import script from "./autocomplete-program.vue?vue&type=script&lang=js&"
export * from "./autocomplete-program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports